import React from 'react';

export default function ResetLOBIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15">
            <g id="reset-lob-icon-6420330" transform="translate(-2.844 -8)">
                <path
                    id="Path_5692"
                    data-name="Path 5692"
                    d="M23.433,16.3a6.786,6.786,0,0,0-6.857-6.7H11.914l.878-.643a.528.528,0,0,0,.11-.75.557.557,0,0,0-.768-.107l-2.7,1.978.447.437h0l2.194,2.143a.557.557,0,0,0,.776,0,.527.527,0,0,0,0-.757l-1.258-1.228h4.984a5.627,5.627,0,1,1-5.76,5.625.549.549,0,0,0-1.1,0,6.859,6.859,0,0,0,13.713,0Z"
                    transform="translate(-6.589 0)"
                    fill="#243b5f"
                />
            </g>
        </svg>
    );
}
